'use client'
import { useEffect, useRef, useState } from "react"

interface ReplyMessageProps {
  message: string
}

export function ReplyMessage({ message }: ReplyMessageProps) {

  const [displayMessage, setDisplayMessage] = useState({
    text: '',
    key: 0
  })

  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (message !== "") {
      setDisplayMessage({
        text: message,
        key: Date.now()
      })

      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      timerRef.current = setTimeout(() => {
        setDisplayMessage(prev => ({ ...prev, text: '' }))
      }, 5000)
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [message])

  return (
    <div>
      {displayMessage.text && (
        <div className={`p-4 mb-4 bg-light_secondary dark:bg-dark_secondary 
                          shadow-md shadow-ochre_accent text-dark_accent dark:text-light_accent rounded-sm`}>
          <p className="font-semibold">{displayMessage.text}</p>
        </div>
      )}
    </div>
  )
}